module.exports = __webpack_public_path__ + "img/ctrl-pauli-z-stub-mid-1.ff1215ef.svg";